<template>
    <div class="autocomplete-form search-user" :class="{'is-open' : (showResults && results.length)}">
        <field-input v-model="query" :with-placeholder="withPlaceholder" @input="search" :placeholder="placeholder"></field-input>
        <button class="clear" @click="clear" v-if="selectedUser"><i class="fa fa-times"></i></button>
        <div class="results" v-if="showResults && results.length">
                <div class="list">
                    <button v-for="result in results"
                            :class="{ 'selected': (selectedUser && result.id == selectedUser.id) }"
                            :key="result.id"
                            v-text="result.name"
                            @click="selectResult(result)"></button>
                </div>
        </div>
        <button class="btn-outside" @click="closeResults" v-if="showResults && results.length"></button>
    </div>
</template>
<script>
    export default {

        props: {
            value: {
                required: false,
            },
            filter: {
                type: String,
                required: false,
                default: '',
            },
            withPlaceholder: {
                type: Boolean,
                required: false,
                default: false,
            },
            placeholder: {
                type: String,
                required: false,
                default: 'User'
            },
            withoutMe: {
                type: Number,
                required: false,
                default: 1,
            }
        },

        data() {
            return {
                selectedUser: null,
                showResults: false,
                searchKey: '',
                results: [],
                query: '',
            }
        },

        mounted() {
            if (this.value) {
                this.initSelected();
            }
        },

        methods: {

            search: _.debounce(function () {
                if (this.query != '') {
                    axios.get(`/search-user?query=${this.query}&filter=${this.filter}&without-me=${this.withoutMe}`).then(response => {
                        this.showResults = true;
                        this.results = this.query ? response.data.users : [];
                        if (this.results.length > 1) return;
                    });
                }
            }, 250),

            initSelected() {
                axios.post(`/search-user`, {user_id: this.value}).then(response => {
                    if (response.data.user.id == this.value) {
                        this.selectedUser = response.data.user;
                        this.query = response.data.user.name;
                    }
                });
            },

            selectResult(result) {
                this.selectedUser = result;
                this.query = this.selectedUser.name;
                this.$emit('input', this.selectedUser.id);
                this.$emit('change', this.selectedUser.id);
                this.$emit('user', this.selectedUser);
                this.closeResults();
            },

            clear() {
                this.query = '';
                this.results = [];
                this.selectedUser = null;
                this.$emit('input', null);
                this.$emit('change', null);
                this.$emit('user', null);
            },

            closeResults() {
                this.showResults = false
                if (this.query) {
                    if (!this.selectedUser || (this.selectedUser && (this.query != this.selectedUser.name))) {
                        this.clear();
                    }
                }
            }
        }
    }
</script>
